import styled from 'styled-components';
export const DashboardPrintCoverPageDiv = styled.div.withConfig({
  displayName: "PrintPreviewStyledDivs__DashboardPrintCoverPageDiv",
  componentId: "xtasal-0"
})(["@media print{height:250mm !important;display:block !important;color:black;", "}display:none;"], props => props.idgMeetingContent ? `margin-bottom: 3cm !important;` : `margin-bottom: 1cm !important;`);
export const DashboardPrintCoverPageInfoDiv = styled.div.withConfig({
  displayName: "PrintPreviewStyledDivs__DashboardPrintCoverPageInfoDiv",
  componentId: "xtasal-1"
})(["@media print{border:solid black;position:relative;", " width:85%;margin:0 auto;div > p > span{font-size:9pt;font-weight:700;}div > p{overflow-wrap:break-word;}}"], props => props.idgMeetingContent ? `top: 7.5% !important;` : `top: 15% !important;`);
export const DashboardPrintCoverPageColumnDiv = styled.div.withConfig({
  displayName: "PrintPreviewStyledDivs__DashboardPrintCoverPageColumnDiv",
  componentId: "xtasal-2"
})(["@media print{padding:1rem 1rem 0 1rem;width:50%;}"]);
export const PrintPreviewOnlyFooterDiv = styled.div.withConfig({
  displayName: "PrintPreviewStyledDivs__PrintPreviewOnlyFooterDiv",
  componentId: "xtasal-3"
})(["@media print{z-index:1;display:block !important;position:fixed;padding-left:0.75cm;padding-right:0.75cm;bottom:0;left:0;right:0;color:black;}display:none;"]);
export const PrintPreviewTextContainer = styled.div.withConfig({
  displayName: "PrintPreviewStyledDivs__PrintPreviewTextContainer",
  componentId: "xtasal-4"
})(["display:flex;justify-content:space-between;"]);
export const PrintPreviewHeaderDiv = styled.div.withConfig({
  displayName: "PrintPreviewStyledDivs__PrintPreviewHeaderDiv",
  componentId: "xtasal-5"
})(["@media print{z-index:1;display:block !important;position:fixed;padding-left:0.75cm;padding-right:0.75cm;top:0;left:0;right:0;color:black;div > p > span{font-size:9pt;font-weight:700;}}display:none;"]);
export const IDGMeetingPrintPreviewDiv = styled.div.withConfig({
  displayName: "PrintPreviewStyledDivs__IDGMeetingPrintPreviewDiv",
  componentId: "xtasal-6"
})(["@media print{position:relative;top:10%;width:85%;margin:0 auto;}"]);
export const ChangesReviewedDiv = styled.div.withConfig({
  displayName: "PrintPreviewStyledDivs__ChangesReviewedDiv",
  componentId: "xtasal-7"
})(["@media print{margin-left:1.5cm;}"]);
export const CompAssessmentTitleP = styled.p.withConfig({
  displayName: "PrintPreviewStyledDivs__CompAssessmentTitleP",
  componentId: "xtasal-8"
})(["@media print{font-size:14pt;font-weight:700;}"]);
export const TableOfContentsDiv = styled.div.withConfig({
  displayName: "PrintPreviewStyledDivs__TableOfContentsDiv",
  componentId: "xtasal-9"
})(["@media print{margin-top:0.5cm;}"]);
export const TableOfContentsTitleP = styled.p.withConfig({
  displayName: "PrintPreviewStyledDivs__TableOfContentsTitleP",
  componentId: "xtasal-10"
})(["@media print{font-size:12pt;font-weight:700;}"]);
export const FlexDiv = styled.div.withConfig({
  displayName: "PrintPreviewStyledDivs__FlexDiv",
  componentId: "xtasal-11"
})(["display:flex;"]);
export const TextCenterDiv = styled.div.withConfig({
  displayName: "PrintPreviewStyledDivs__TextCenterDiv",
  componentId: "xtasal-12"
})(["text-align:center;"]);
export const FontBoldSpan = styled.span.withConfig({
  displayName: "PrintPreviewStyledDivs__FontBoldSpan",
  componentId: "xtasal-13"
})(["font-weight:bold;"]);
export const AllergiesDiagnosesColumnDiv = styled.div.withConfig({
  displayName: "PrintPreviewStyledDivs__AllergiesDiagnosesColumnDiv",
  componentId: "xtasal-14"
})(["width:100%;padding:1rem;"]);
export const PatientInfoContainerDiv = styled.div.withConfig({
  displayName: "PrintPreviewStyledDivs__PatientInfoContainerDiv",
  componentId: "xtasal-15"
})(["width:100%;display:flex;justify-content:space-evenly;"]);